import { AllWinesByWineListOrderField } from "../types/__generated__/globalTypes";

export interface WineSortingOption {
  id: string;
  name: string;
}

type TranslateSortingOptions = (key: string, options: { returnObjects: true }) => unknown;

/**
 * Returns the options of the wines sort dropdown from the wine pages translations.
 * Guests have no taste profile, so sorting by best match is only offered to members.
 *
 * `t` hands back the raw key instead of the array when the English translations are missing,
 * e.g. their download failed. That gives no options rather than a value callers would crash on.
 */
export const getWineSortingOptions = (t: TranslateSortingOptions, isMember: boolean): WineSortingOption[] => {
  const options = t("winePages:WINE_SORTER_ARR", { returnObjects: true });
  if (!Array.isArray(options)) return [];

  const sortingOptions: WineSortingOption[] = options;
  return isMember
    ? sortingOptions
    : sortingOptions.filter(({ id }) => id !== AllWinesByWineListOrderField.MEMBER_LIKELIHOOD_DESC);
};
